import { SignOutButton } from "@/components/auth/sign-out-button";
import {
  SITE_HEADER_FRAME_CLASS,
  SITE_HEADER_SURFACE_CLASS,
} from "@/components/shared/site-header-frame";
import { SiteHeaderLogo } from "@/components/shared/site-header-logo";
import { cn } from "@/lib/utils";

/**
 * The header of the account flows (onboarding, the host's list creation): the product's one
 * frame and wordmark, and this screen's own particular — the way out of the session. It stays at
 * the top while the step scrolls, as `.auth-top` does (Onboarding V2 §3).
 *
 * `z-40`, under the dialog layer (`z-50`): the prototype's calendar scrim (z 1000) covers its
 * `.auth-top` (z 200), and a header at 200 here would stand undimmed over the date dialogs of
 * these screens.
 */
export function DashboardTopbar({ showSignOut = true }: { showSignOut?: boolean }) {
  return (
    <header className={cn("sticky top-0 z-40", SITE_HEADER_FRAME_CLASS, SITE_HEADER_SURFACE_CLASS)}>
      <SiteHeaderLogo href="/" />
      {/* No session, nothing to leave: the onboarding header is the wordmark alone (`.auth-top`). */}
      {showSignOut && <SignOutButton className="h-auto gap-[7px] p-0 text-[12px] normal-case tracking-[0.06em] text-fg-muted hover:bg-transparent hover:text-primary" />}
    </header>
  );
}
